import React from 'react';
import PropTypes from 'prop-types';

const withCustomInputHoc = (WrappedComponent) => {
  class HOC extends React.Component {
    constructor (props) {
      super(props);
      this.state = {
        hasError: false
      };
      this.errorFn = this.errorFn.bind(this);
      this.validFn = this.validFn.bind(this);
      this.isValid = this.isValid.bind(this);
      this.inputRef = this.inputRef.bind(this);
      this.onChangeErrorHandler = this.onChangeErrorHandler.bind(this);
    }

    onChangeErrorHandler (dataValue, closeFn) {
      this.setState({
        hasError: false
      }, () => {
        if (this.props.handleListClick) {
          this.props.handleListClick(dataValue, closeFn);
        }
      });
    }

    getValue () {
      const { value } = this.target.dataset || {};
      return value;
    }

    isValid () {
      let errorFree = true;
      const { optional, defaultOption } = this.props;
      const { value } = this.target.dataset || {};

      if ((!optional && !value) || (!optional && value === defaultOption)) {
        this.errorFn();
        errorFree = false;
      } else {
        this.validFn();
      }

      return errorFree;
    }

    validFn () {
      this.setState({ hasError: false });
    }

    errorFn () {
      this.setState({ hasError: true });
    }

    inputRef (ref) {
      this.target = ref;
      return this.target;
    }

    clearValue () {
      this.setState({ hasError: false });
    }

    render () {
      const { hasError } = this.state;
      return (
        <WrappedComponent
          inputRef={this.inputRef}
          hasError={hasError}
          validFn={this.validFn}
          onChangeErrorHandler={this.onChangeErrorHandler}
          {...this.props}
        />
      );
    }
  }
  HOC.propTypes = {
    optional: PropTypes.bool,
    handleListClick: PropTypes.func,
    defaultOption: PropTypes.string
  };
  return HOC;
};

export default withCustomInputHoc;
